import React from "react";
import EntryColor from "../../wagerTypes/EntryColor";
import { MDBTooltip } from "mdb-react-ui-kit";

const EntryItem = ({ entry, deleteEntryBet, errorMsg, error }) => {
  let errordiv,
    deleteIcon = (
      <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="Delete">
        <i
          className="fa fa-trash mt-2"
          style={{ color: "#005580" }}
          title="Delete"
          onClick={() =>
            deleteEntryBet(
              entry.wagerType,
              entry.saddleNum,
              entry.position,
              entry.raceID,
            )
          }
        ></i>
      </MDBTooltip>
    );

  if (errorMsg !== "NoWPS" && errorMsg !== "YesWPS") {
    errordiv = (
      <div
        className="alert alert-danger"
        style={{ width: "100%" }}
        role="alert"
      >
        {errorMsg}
      </div>
    );
  }

  if (errorMsg === "YesWPS") {
    deleteIcon = "";
  }

  return (
    <li
      className="list-group-item  justify-content-between"
      key={entry.saddleNum}
      style={error ? { pointerEvents: "none", opacity: 0.6 } : {}}
    >
      <div className="row">
        <div style={{ width: "95%" }}>
          <span className="" style={{ display: "inline-block" }}>
            <EntryColor entryNum={entry.entryNum} saddleNum={entry.saddleNum} />
          </span>
          <p className="ml-2" style={{ display: "inline-block" }}>
            {entry.entryName}
          </p>
        </div>
        {!error && deleteIcon}
        {errordiv}
      </div>
    </li>
  );
};

export default EntryItem;
